import { render, staticRenderFns } from "./KkmSetBlockStatusForm.vue?vue&type=template&id=60e228e8&"
import script from "./KkmSetBlockStatusForm.vue?vue&type=script&lang=js&"
export * from "./KkmSetBlockStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports